import { AlertsFetcher } from "./fetchers/alerts.fetcher";
import { ScheduleFetcher } from "./fetchers/schedule.fetcher";
import { AlertsTransformer } from "./transformers/alerts.transformer";
export class OdontoConectaService {
    constructor(urls) {
        this.urls = urls;
    }
    async fetchAllData(scheduleId) {
        const schedule = await new ScheduleFetcher(scheduleId, this.urls).fetch();
        const alerts = AlertsTransformer.transform(await new AlertsFetcher(schedule.patient.id, this.urls).fetch());
        const data = {
            ...schedule,
            more: {
                alerts
            }
        };
        return data;
    }
}
